import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const StyledLicenceInfo = styled(Grid)`
  display: grid;
  background: ${colors.primary900};
  padding: 4px 4px 4px 10px;
  border-radius: 2px;
  & li,
  span {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0%;
    color: ${colors.white};
  }
`;
